import { BlockOverrides } from 'baseui/block';
import { ButtonOverrides } from 'baseui/button';

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      height: 'fit-content',
      paddingTop: '8px',
      paddingLeft: '24px',
      paddingRight: '24px',
      paddingBottom: '8px',
    },
  },
};

export const BUTTON: ButtonOverrides = {
  BaseButton: {
    style: {
      width: '100%',
    },
  },
};
